import { useQuery } from '@tanstack/react-query';

import { tokensClient } from 'services/connectivity/token/client';
import { TokenResponse } from 'services/connectivity/token/types';
import { errorDeserialize } from 'helpers/error-deserializer';

interface UseGetTokenDetails {
  tokenDetails?: TokenResponse;
  error?: unknown;
  isLoading: boolean;
}

export const fetchTokenDetails = async (accessToken: string): Promise<TokenResponse> => {
  const { error, result } = await tokensClient.getInfo(accessToken);
  if (error) {
    throw errorDeserialize(error);
  }

  return result;
};

export const useGetTokenDetails = (accessToken: string): UseGetTokenDetails => {
  const { data, error, isLoading } = useQuery({
    queryKey: ['get-token-details', accessToken],
    queryFn: () => fetchTokenDetails(accessToken),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2,
    enabled: !!accessToken,
  });

  return {
    tokenDetails: data,
    error,
    isLoading,
  };
};
